export const iconFontAwesomeArrowsArrowDown19 = (
	<i className="fa-solid fa-arrow-down-1-9"></i>
);
